import axios from 'axios';
import moment from 'moment-timezone';
import $ from 'jquery';
import { SDLUtil, MFAUtil } from '@/utils';

const getUserInfo = (formData) => axios.post(`${SDLUtil.API_URL}/noauth/login/id`, formData);
const getNewEpTrayUserInfo = formData => axios.post(`${SDLUtil.API_URL}/noauth/login/new-eptray`, formData);

const setHeaderToken = token => {
  axios.defaults.headers.common['x-auth-token'] = token;
};
const setRefreshHeaderToken = token => {
  axios.defaults.headers.common['x-auth-refresh-token'] = token;
};

export default {
  async login(userId, password) {
    try {
      const formData = new FormData();
      formData.append('userId', userId);
      formData.append('password', password);
      const userInfoResponse = await getUserInfo(formData);
      this.setToken(userInfoResponse.data.jwtToken);
      return Object.assign(userInfoResponse.data, { code: 'authOk' });
    } catch (err) {
      return err.data.error;
    }
  },
  async loginNewEpTray(userInfo, key) {
    try {
      const formData = new FormData();
      formData.append('encodeUserInfo', userInfo);
      formData.append('encodeAesKey', key);
      const userInfoResponse = await getNewEpTrayUserInfo(formData);
      this.setToken(userInfoResponse.data.jwtToken);

      return Object.assign(userInfoResponse.data, { code: 'authOk' });
    } catch (err) {
      // console.error('login:', err);
      return err.data.error;
    }
  },
  async logout(errCode) {
    if (!errCode) {
      await axios.put(`${SDLUtil.API_URL}/noauth/logout?checkPrivacyPolicy=true`);
      await axios
        .get(`${SDLUtil.API_URL}/noauth/saml-request-logout`)
        .then((redirect) => {
          $.ajax({
            dataType: 'jsonp',
            url: redirect.data,
            type: 'GET',
          });
        });
    }
    await this.setToken('');
    await this.setRefreshToken('');
  },
  setToken(token) {
    if (token === '' || token === null) {
        setHeaderToken('');
        localStorage.setItem('userToken', '');
    } else {
      setHeaderToken(token);
      localStorage.setItem('userToken', `${token}`);
    }
  },
  setRefreshToken(token) {
    if (token === '' || token === null) {
      // impersonator check
      if (localStorage.getItem('adminToken') !== null && localStorage.getItem('adminToken') !== '') {
        // call axios
        axios.put(`${SDLUtil.API_URL}/impersonation/logout`).then(() => {});
        this.setRefreshToken(localStorage.getItem('adminToken'));
        localStorage.setItem('adminToken', '');
        axios.defaults.headers.common['original-user-id'] = '';
        document.location = `${SDLUtil.WEB_CONTEXT_PATH}/`;
      } else {
        setRefreshHeaderToken('');
        localStorage.setItem('user', '');
        localStorage.setItem('refreshToken', '');
        MFAUtil.removeMFAToken();
      }
    } else {
      setRefreshHeaderToken(token);
      const userJson = SDLUtil.parseJwt(token);
      if ('systemAdminUser' in userJson) delete userJson.systemAdminUser;
      localStorage.setItem('user', JSON.stringify(userJson));
      localStorage.setItem('refreshToken', `${token}`);
      const defaultLang = (window.navigator.userLanguage || window.navigator.language || SDLUtil.DEFAULT_LANG).replace('-', '_');
      SDLUtil.setI18nLanguage(SDLUtil.getLoginedUserInfo().language || defaultLang); // Change to language setting of login user
    }
  }
};



// WEBPACK FOOTER //
// ./src/service/loginService.js